import React from 'react';
import styled from 'styled-components';

export default styled.ul`
  border-bottom: 1px solid #eeeae7;
  display: inline-block;
  list-style: none;
  margin: 0;
`;
